"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValue = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _ObjectDetailBar = require("components/ObjectDetailBar");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var HeaderBlock = (_class = (_temp =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(HeaderBlock, _Block);

  function HeaderBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, HeaderBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(HeaderBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "headerBackground", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "image", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "purchaseButtonInfo", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(HeaderBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: _classList.default.join('spotlight-header', this.headerBackground ? 'variable-background' : null),
        style: this.headerBackground ? _base.default.styleForBackgroundObject(this.headerBackground) : {}
      }, _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, this.image && _react.default.createElement("img", {
        src: this.image,
        alt: ""
      }), this.title && _react.default.createElement("h2", null, this.title), _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "purchase-wrap"
      }, _react.default.createElement(_ObjectDetailBar.ObjectDetailButton, this.state.purchaseButtonInfo))), this.summary && _react.default.createElement("div", {
        style: {
          display: 'contents'
        },
        dangerouslySetInnerHTML: {
          __html: "<hr>".concat(this.summary)
        }
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var purchaseButtonInfo = _ref.purchaseButtonInfo;
      return {
        purchaseButtonInfo: Function('', "return ".concat(purchaseButtonInfo)).call(null)
      };
    }
  }]);
  return HeaderBlock;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headerBackground", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "purchaseButtonInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = HeaderBlock;
var getValue = HeaderBlock.request_applicationHeaderForBlock;
exports.getValue = getValue;